import type { BrandSitePage } from "@/lib/brand-site-api";

/** 卡片「写入草稿」成功后传给设计页：立刻更新左侧，不必等 list 往返。 */
export type BrandSiteDraftMutationHint = {
  slug?: string;
  page?: {
    id?: number;
    slug?: string;
    title?: string | null;
    html_content?: string;
    is_home?: boolean;
  };
};

/** 用 apply 返回的 page 合并进列表；缺字段时沿用旧页。 */
export function mergeBrandSitePageAfterDraftApply(
  pages: BrandSitePage[],
  page: BrandSiteDraftMutationHint["page"] | null | undefined,
): BrandSitePage[] {
  const slug = page?.slug?.trim();
  if (!slug || typeof page?.html_content !== "string") return pages;

  const existing = pages.find((item) => item.slug === slug);
  const next: BrandSitePage = {
    id: typeof page.id === "number" && page.id > 0 ? page.id : (existing?.id ?? 0),
    slug,
    title: page.title?.trim() || existing?.title || slug,
    html_content: page.html_content,
    is_home: typeof page.is_home === "boolean" ? page.is_home : (existing?.is_home ?? slug === "index"),
  };

  const index = pages.findIndex((item) => item.slug === slug);
  if (index < 0) return [...pages, next];
  const copy = pages.slice();
  copy[index] = { ...pages[index], ...next, id: next.id || pages[index].id };
  return copy;
}
